import { render } from "./HomeCarousel2.vue?vue&type=template&id=3ef6b8c0"
import script from "./HomeCarousel2.vue?vue&type=script&lang=js"
export * from "./HomeCarousel2.vue?vue&type=script&lang=js"

import "./HomeCarousel2.vue?vue&type=style&index=0&id=3ef6b8c0&lang=scss"

import exportComponent from "/Users/matteomelillo/Dev/wpHeadless/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__